export default {
	getHeaders(role = 'admin') {
		if(role !== 'admin'){
			return {
				field:  [
					{
						field: "name",
						title: 'personName',
						align: 'center',
						width: '12.5%'
					},
					{
						field: "email",
						title: "E-mail",
						align: 'center',
						width: '12.5%'
					},
					{
						field: "phone",
						title: 'phone',
						align: 'center',
						width: '12.5%'
					},
					{
						field: "tickets_count",
						title: 'totalTicketsAmount',
						align: 'center',
						width: '12.5%'
					},
					{
						field: "tickets_active_count",
						title: 'activatedTickets',
						align: 'center',
						width: '12.5%'
					},
					{
						field: "current_manager",
						title: 'manager',
						align: 'center',
						width: '12.5%'
					},
					{
						field: "task",
						title: 'task',
						align: 'center',
						width: '12.5%'
					},
					{
						field: "chat_messages_count",
						title: "Message Count",
						align: 'center',
						width: '12.5%'
					},
					{
						field: "actions",
						title: 'actions',
						align: 'center',
						width: '12.5%'
					},
				],
				tabs: [
					{ key: "clients", title: "clients" },
					{ key: "ban_clients", title: "ban_clients" }
				]
			}
		}
		return {
			field: [
				{
					field: "name",
					title: 'personName',
					align: 'center',
					width: '12.5%'
				},
				{
					field: "email",
					title: "E-mail",
					align: 'center',
					width: '12.5%'
				},
				{
					field: "phone",
					title: 'phone',
					align: 'center',
					width: '12.5%'
				},
				{
					field: "tickets_count",
					title: 'totalTicketsAmount',
					align: 'center',
					width: '12.5%'
				},
				{
					field: "tickets_active_count",
					title: 'activatedTickets',
					align: 'center',
					width: '12.5%'
				},
				{
					field: "current_manager",
					title: 'manager',
					align: 'center',
					width: '12.5%'
				},
				{
					field: "income",
					title: 'Beitrag, €',
					align: 'center',
					width: '12.5%'
				},
				{
				  field: "unread_messages_count",
				  title: "Message Count",
				  align: 'center',
				  width: '12.5%'
				},
				{
					field: "actions",
					title: "actions",
					align: 'center',
					width: '12.5%'
				},
			],

			tabs: [
				{ key: "clients", title: "clients" },
				{ key: "ban_clients", title: "ban_clients" }
			]
		}
	}
};
